import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import Slider from './Slider';
import NumberInput from '../NumberInput/NumberInput';
import classes from './SliderInput.styles.less';
export default function SliderInput({ className, value, onChange, trackSize = 200, min = 0, max = 100, }) {
    return (_jsxs("div", { className: cx(classes.wrapper, className), children: [_jsx(NumberInput, { className: classes.input, value: value, onChange: onChange, min: min, max: max }), _jsx(Slider, { min: min, max: max, value: value, onChange: onChange, trackSize: trackSize })] }));
}
